import { FiArrowUp, FiGithub, FiLinkedin, FiMail } from "react-icons/fi";

const navLinks = [
  { name: "About", href: "#about" },
  { name: "Work", href: "#projects" },
  { name: "Skills", href: "#skills" },
  { name: "Journey", href: "#journey" },
  { name: "Contact", href: "#contact" },
];

const socials = [
  { Icon: FiGithub, href: "https://github.com/albinademaj", label: "GitHub" },
  {
    Icon: FiLinkedin,
    href: "https://www.linkedin.com/in/albina-demaj-881293300/",
    label: "LinkedIn",
  },
  { Icon: FiMail, href: "mailto:demajalbina3@gmail.com", label: "Email" },
];

const Footer = () => (
  <footer className="relative overflow-hidden border-t border-cream/10 bg-ink px-5 py-14 sm:px-8">
    <div className="shell">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <a href="#home" className="display text-2xl text-cream">
            Albina<span className="text-sage">.</span>
          </a>

          <p className="mt-4 text-sm leading-7 text-cream/45">
            Full-stack developer working with React, Laravel and everything
            needed to turn an idea into a product that ships.
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="link-underline text-sm text-cream/55 transition-colors hover:text-mint"
            >
              {link.name}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {socials.map(({ Icon, href, label }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith("http") ? "_blank" : undefined}
              rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
              aria-label={label}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/10 text-cream/60 transition duration-300 hover:-translate-y-1 hover:border-mint/40 hover:text-mint"
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-4 border-t border-cream/10 pt-7 text-[12.5px] text-cream/35 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} Albina Demaj — All rights reserved.</p>

        <p className="font-mono">Designed &amp; built with React + Tailwind</p>

        <a
          href="#home"
          className="inline-flex items-center gap-2 transition-colors hover:text-mint"
        >
          Back to top
          <FiArrowUp />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
